import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupAktieServiceConfig = {
  name: "GroupAktie",
  annotations: []
} as ServiceConfig;